let firebasePromise = null;

export const getFirebase = () => {
  if (!firebasePromise) {
    firebasePromise = (async () => {
      const { initializeApp } = await import('firebase/app');
      const {
        getFirestore,
        collection,
        getDocs,
        getDoc,
        doc,
        addDoc,
        updateDoc,
        deleteDoc,
        query,
        where,
        orderBy,
        limit, // exported as firestoreLimit usually
        serverTimestamp
      } = await import('firebase/firestore');
      
      const {
        getAuth,
        signInWithEmailAndPassword,
        signOut,
        onAuthStateChanged
      } = await import('firebase/auth');
      
      const {
        getStorage,
        ref,
        uploadBytes,
        getDownloadURL,
        deleteObject
      } = await import('firebase/storage');

      const firebaseConfig = {
          apiKey: "AIzaSyBJjuOLh1xiP8JvFKN_GNr8ALa16_0pyiA",
          authDomain: "edzurelegalllp-123bc.firebaseapp.com",
          projectId: "edzurelegalllp-123bc",
          storageBucket: "edzurelegalllp-123bc.firebasestorage.app",
          messagingSenderId: "754696717789",
          appId: "1:754696717789:web:2ed747644fd7e9427d2234",
          measurementId: "G-YMZ0BJEHZ0"
      };

      const app = initializeApp(firebaseConfig);
      const db = getFirestore(app);
      const auth = getAuth(app);
      const storage = getStorage(app);

      return {
        app, db, auth, storage,
        firestore: { collection, getDocs, getDoc, doc, addDoc, updateDoc, deleteDoc, query, where, orderBy, limit, serverTimestamp },
        authLib: { signInWithEmailAndPassword, signOut, onAuthStateChanged },
        storageLib: { ref, uploadBytes, getDownloadURL, deleteObject }
      };
    })();
  }
  return firebasePromise;
};
